import { request } from '@/utils/request'
export default {
    masterPic: (params, loading) => {
        return request('/api/businessmainprocess/news', params, loading)
    },
    newsList: (params, loading) => {
        return request('/api/newsinformation/list', params, loading)
    },
    newsDel: (params, loading) => {
        return request('/api/newsinformation/del', params, loading)
    },
    newsAdd: (params, loading) => {
        return request('/api/newsinformation/add', params, loading)
    },
    newsEdit: (params, loading) => {
        return request('/api/newsinformation/edit', params, loading)
    },
}


// WEBPACK FOOTER //
// ./src/api/newsViews.js